import SVGArrowCircle from '../icons/arrow-w-circle.svg?inline'
import SVGArrowCircleLeft from '../icons/arrow-w-circle-left.svg?inline'
import SVGCart from '../icons/cart.svg?inline'
import SVGPlus from '../icons/plus.svg?inline'
import SVGMinus from '../icons/minus.svg?inline'
import SVGBasket from '../icons/basket.svg?inline'
import SVGUser2 from '../icons/user2.svg?inline'
import SVGCross from '../icons/cross.svg?inline'

export default {
  SVGArrowCircle,
  SVGArrowCircleLeft,
  SVGCart,
  SVGPlus,
  SVGMinus,
  SVGBasket,
  SVGUser2,
  SVGCross
}
